import { render, staticRenderFns } from "./NewTable.vue?vue&type=template&id=484f1262&scoped=true"
import script from "./NewTable.vue?vue&type=script&lang=ts"
export * from "./NewTable.vue?vue&type=script&lang=ts"
import style0 from "./NewTable.vue?vue&type=style&index=0&id=484f1262&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f1262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484f1262')) {
      api.createRecord('484f1262', component.options)
    } else {
      api.reload('484f1262', component.options)
    }
    module.hot.accept("./NewTable.vue?vue&type=template&id=484f1262&scoped=true", function () {
      api.rerender('484f1262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/table/NewTable.vue"
export default component.exports